import { commentThreads } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const avatarTone: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-foreground-950",
  secondary: "bg-secondary-600 text-background-50",
};

export default function CommentPreview() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-site mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <SectionHeading
            eyebrow="评论区"
            title="评论区就是主场，对线与追评都在这里"
            desc="帖子下面的每一层都能被回复，观点不同就摆事实继续聊。下面是从评论区随手挑出来的几段讨论，看看其他人是怎么交流的。"
          />
          <a
            href="#download"
            className="self-start lg:self-auto h-10 px-5 rounded-md bg-secondary-500 text-background-50 text-sm font-medium inline-flex items-center gap-2 hover:bg-secondary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-chat-3-line"></i>
            进入评论区
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 lg:grid-cols-3 gap-5">
          {commentThreads.map((thread, index) => (
            <article
              key={thread.id}
              className={`animate-fade-up flex flex-col rounded-lg border border-background-200 bg-background-100 p-4 md:p-5 ${
                index === 1 ? "delay-100" : index === 2 ? "delay-200" : ""
              }`}
            >
              <div className="flex items-center justify-between gap-3">
                <a
                  href="#topics"
                  className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-700 hover:text-primary-700 transition-colors"
                >
                  <i className="ri-hashtag"></i>
                  {thread.topic}
                </a>
                <span className="text-xs text-foreground-500 whitespace-nowrap">
                  {thread.time}
                </span>
              </div>

              <div className="mt-4 flex items-center gap-2.5">
                <span
                  className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-medium shrink-0 ${
                    avatarTone[thread.tone] ?? avatarTone.primary
                  }`}
                >
                  {thread.initial}
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-950 truncate">
                    {thread.user}
                  </p>
                  <p className="text-xs text-foreground-500">发帖人</p>
                </div>
              </div>

              <p className="mt-3.5 text-sm text-foreground-700 leading-relaxed">
                {thread.content}
              </p>

              <div className="mt-4 pt-3 border-t border-background-200 space-y-3">
                {thread.replies.map((reply) => (
                  <div key={reply.user} className="flex gap-2.5">
                    <span className="w-6 h-6 rounded-full bg-background-200 text-foreground-700 text-[11px] flex items-center justify-center shrink-0">
                      {reply.initial}
                    </span>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      <span className="text-foreground-900 font-medium">
                        {reply.user}
                      </span>
                      ：{reply.content}
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-auto pt-4 flex items-center gap-5 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-thumb-up-line"></i>
                  </span>
                  {thread.likes}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-chat-3-line"></i>
                  </span>
                  {thread.replies.length} 条回复
                </span>
                <span className="inline-flex items-center gap-1.5 ml-auto text-primary-700">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-send-line"></i>
                  </span>
                  私信他
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}